<template>
  <div class="form-group row">
    <div class="col-sm-10 text-right">
      <div class="checkbox mt-2">
        <label class="mb-0">
          <div :class="cssclass" style="position: relative;">
            <input v-model="accepted" name="accepted" type="checkbox" style="position: absolute; opacity: 0;">
            <ins class="iCheck-helper" style="position: absolute; top: 0%; left: 0%; display: block; width: 100%; height: 100%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;"></ins>
          </div><span class="ml-2"> I accept the terms of service</span>
        </label>
      </div>
    </div>
    <div class="col-sm-2 text-right">
      <button class="btn btn-primary" type="submit" :disabled="!accepted">Submit</button>
    </div>
  </div>
</template>


<script>

export default {
  data () {
    return {
      accepted: false
    }
  },
  computed: {

    cssclass() {
      let cssClass = 'icheckbox_square-blue';
      if (this.accepted) {
        cssClass += ' checked';
      }
      return cssClass;
    }
  }
}
</script>
